const productConfig = {
  levels: {
    'entry': 5,
    'enhanced': 6,
    'allInclusive': 7,
    'standard': 8,
    'enhancedExt': 9,
    'comprehensive': 10,
    'privateHospital': 11,
    'nhsTreatment': 12,
    'dentalOnly': 13,
    'completeHealth': 14,
  },
  lists: {
    allInclusiveList: {
      list: [
        'No overall maximum annual benefit',
        'Hospital Treatment (in-patient and day-patient)',
        'Out-patient treatment',
        'Cancer cover',
        'Remote GP Access',
        'Health & Wellbeing Helpline',
        'NHS Hospital cash benefits for cancer and non-cancer conditions',
        'Overseas emergency treatment',
        'Optical, dental treatment & health screening',
        'Shared Responsibility from £500'
      ],
      optional: ['Premium Hospitals'],
    },
    cashPlanList: [
      'Optical and dental treatment',
      'Specialist consultations',
      'A range of therapies',
      'A choice of reimbursement levels',
      'Remote GP access',
      'Health & Wellbeing Helpline'
    ],
    comprehensiveList: {
      list: [
        'In-patient and Day-patient treatment',
        'Out-patient treatment, diagnostics and scans (unlimited)',
        'NHS Hospital cash benefits for cancer and non-cancer',
        'Shared Responsibility',
        'Cancer cover',
        'Optical treatment cash benefit (up to £200)',
        'Dental and optical treatment cash benefits (up to £450)',
        'Health screening (up to £200)',
        'Overseas Emergency Treatment',
      ],
      optional: ['Premium Hospitals'],
    },
    dentalOnlyList: [
      'Choice of NHS or private',
      'General dental treatment',
      'Dental injuries',
      'Restorative treatment',
      'NHS hospital cash benefit',
    ],
    enhancedList: {
      list: [
        'No overall maximum annual benefit',
        'Hospital Treatment (in-patient and day-patient)',
        'A range of out-patient options',
        'Remote GP Access',
        'Health & Wellbeing Helpline',
        'NHS Hospital cash benefits for cancer and non-cancer conditions',
        'Shared Responsibility from £250'
      ],
      optional: [
        'Cancer cover',
        'Overseas emergency treatment',
        'Optical and dental treatment',
        'Premium Hospitals',
      ]
    },
    enhancedListExt: {
      list: [
        'In-patient and Day-patient treatment',
        'Out-patient treatment, diagnostics and scans (up to £1,500)',
        'NHS Hospital cash benefits for cancer and non-cancer',
        'Shared Responsibility',
        'Cancer cover',
        'Dental and optical treatment cash benefits (up to £200)',
        'Health screening (up to £200)',
      ],
      optional: [
        'Overseas Emergency Treatment',
        'Premium Hospitals',
      ]
    },
    entryList: { 
      list: [
        'Maximum annual benefit limit of £50,000',
        'Hospital Treatment (in-patient and day-patient)',
        'Limited Out-patient treatment',
        'Remote GP Access',
        'Health & Wellbeing Helpline',
        'NHS Hospital cash benefits for cancer and non-cancer conditions',
        'Optical and dental treatment'
      ],
      optional: [
        'Limited cancer cover'
      ]
    },
    myBusinessList: [
      'Private Hospital treatment',
      'Cancer cover',
      'A range of therapies',
      'Unrestricted hospital choice',
      'Remote GP access',
      'Employee Assistance Programme',
      'Optical, Dental, and other Cash Plan benefits'
    ],
    privateHospitalList: [
      'Hospital treatment (in-patient and day-patient)',
      'Specialist consultations & tests',
      'Cancer cover',
      'Overseas emergency treatment',
      'Unrestricted hospital choice',
      'Remote GP access',
      'Health & Wellbeing Helpline'
    ],
    standardList: {
      list: [
        'In-patient and Day-patient treatment',
        'Out-patient treatment, diagnostics and scans (up to £350)',
        'NHS Hospital cash benefits for cancer and non-cancer',
        'Shared Responsibility',
        'Cancer cover',
      ],
      optional: [
        'Overseas Emergency Treatment',
        'Premium Hospitals',
      ],
    },
    completeHealthList: {
      list: [
        'No overall maximum annual benefit',
        'Hospital Treatment (in-patient and day-patient)',
        'A range of out-patient options',
        'Remote GP Access',
        'Health & Wellbeing Helpline',
        'NHS Hospital cash benefits for cancer and non-cancer conditions',
        'Control your premium with a range of Shared Responsibility and Excess options'
      ],
      optional: [
        'Cancer cover',
        'Overseas emergency treatment',
        'Cash Extras',
        'Premium Hospitals',
        'Out-patient',
        'Therapy',
        'Mental Health treatment',
        'Winter Sports (UK treatment)',
      ],
    },
  },
  types: {
    'justMe': {
      'id': 1,
      'phrase': 'For you'
    },
    'family': {
      'id': 2,
      'phrase': 'For you and your family'
    },
    'familyExtended': {
      'id': 3,
      'phrase': 'For you and your extended family'
    },
    'business': {
      'id': 4,
      'phrase': 'For your business'
    },
  },
}

export default productConfig;
